import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@emotion/react';

import ClientLogo from './logo--client';
import PlainLogo from '../../../../../researcher/blocks/logo/logo--plain';
import { hasFeature } from '../../../../util/has-feature';
import { useBranding } from '../../../../redux/selectors';

const ParticipantLogo = ({ theme, ...rest }) => {
  const { logo } = useBranding();
  if (logo) {
    return <ClientLogo {...rest} src={logo} />;
  }
  if (hasFeature('branding')) {
    return null;
  }
  return <PlainLogo {...rest} />;
};

ParticipantLogo.propTypes = {
  theme: PropTypes.shape().isRequired,
};

export default withTheme(ParticipantLogo);
